export const abbreviateName = (name: string) => {
  return name.replace(/\B\w+/, '.');
};
